import { Controller } from "@hotwired/stimulus"

// Handles image loading states with skeleton animation
// Usage: data-controller="image-loader" on container
//        data-image-loader-target="image" on img element
//        data-image-loader-target="skeleton" on loading placeholder
export default class extends Controller {
  static targets = ["image", "skeleton"]

  connect() {
    if (this.hasImageTarget) {
      // Check if image is already loaded (cached)
      if (this.imageTarget.complete && this.imageTarget.naturalHeight !== 0) {
        this.showImage()
      } else {
        this.imageTarget.addEventListener("load", () => this.showImage())
        this.imageTarget.addEventListener("error", () => this.showError())
      }
    }
  }

  showImage() {
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.add("hidden")
    }
    if (this.hasImageTarget) {
      this.imageTarget.classList.remove("opacity-0")
      this.imageTarget.classList.add("opacity-100")
    }
  }

  showError() {
    if (this.hasSkeletonTarget) {
      // Replace shimmer with error state
      this.skeletonTarget.innerHTML = `
        <div class="flex flex-col items-center justify-center w-full h-full">
          <svg class="w-6 h-6 mb-1" style="color: var(--text-muted);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        </div>
      `
      this.skeletonTarget.classList.remove("animate-pulse")
    }
    if (this.hasImageTarget) {
      this.imageTarget.classList.add("hidden")
    }
  }
}
